/** @jsx jsx */
import React from "react"
import { jsx, useColorMode, Link as TLink } from "theme-ui"
import { Box } from "@theme-ui/components"
import { Link } from "gatsby"
import ItemTags from "./item-tags"
import ColorModeToggle from "./colormode-toggle"

type ProjectListItemProps = {
  post: {
    slug: string
    title: string
    date: string
    excerpt: string
    description: string
    timeToRead?: number
    tags?: {
      name: string
      slug: string
    }[]
  }
  showTags?: boolean
}



const BlogListItem = ({ post, showTags = true }: ProjectListItemProps) => {
  const [colorMode, setColorMode] = useColorMode()
  const isDark = colorMode === `dark`
  
  return (
  <a href={post.slug} sx={{textDecoration: `none`}}>
  <div 
  sx={{ borderRadius: `50px`, 
       
        background: isDark ? `#313949` :`#eeeeee`,
        padding: `30px 30px 1px 30px`,
        //borderBottom: '2px solid #000',
        //borderStyle: `dotted`,
        boxShadow: isDark ? `9px 9px 30px #292f3d, -9px -9px 30px #394355` : `9px 9px 28px #e0e0e0, -9px -9px 28px #fcfcfc`,
        margin: `30px`,
        
        "&:before, &:after": {
          transition: `all ease-in-out 0.25s`,
        },

        "&:hover": {
          cursor: `pointer`,
          transition: `all ease-in-out 0.25s`,
          // transition: `all ease-in-out 0.9s`,
          background: isDark ? `#2c3341` :`#e5e5e5`,
          //boxShadow: isDark ? `9px 9px 30px #292f3d, -9px -9px 30px #394355` : `9px 9px 28px #e0e0e0, -9px -9px 28px #fcfcfc`,
        },

        "&:focus": {
          outline: `none`
        },

        "&:active": {
          transition: `all ease-in-out 0.25s`,
          //transition: `all ease-in-out 0.9s`,
          //background: isDark ? `#313949` :`#eeeeee`,
          boxShadow: isDark ? `inset 0px 0px 0px #292f3d, inset -0px -0px 0px #394355` : `inset 0px 0px 0px #e0e0e0, inset -0px -0px 0px #fcfcfc`,
          //background: `black`,
        }
      }}>
  <Box mb={4}>
    <TLink as={Link} to={post.slug} sx={{ fontSize: [1, 2, 3], color: `text`, textDecoration: `none !important` }}>
      {post.title}
    </TLink>
    <p sx={{ color: `secondary`, mt: 1, a: { color: `secondary`}, fontSize: [1, 1, 2] }}>
      <time>{post.date}</time>
      {post.tags && showTags && (
        <React.Fragment>
          {` — `}
          <ItemTags tags={post.tags} />
        </React.Fragment>
      )}
    </p>
  </Box>
  </div>
  </a>
  )
}

export default BlogListItem
